import type { ListUsersQuery } from '../../__generated__/graphql/api';

import { distinctProgramNames } from '../../utils/distinctProgramNames';

type ListUsersResultUsers = NonNullable<NonNullable<ListUsersQuery['listUsers']>['users']>;

type ListUsersResultUser = NonNullable<ListUsersResultUsers[number]>;

export interface UserListItem {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  dob: string | null;
  isFriendsAndFam: boolean | null;
  insertedAt: string | null;
  programNames: string[];
}

export const toUserListItem = (user: ListUsersResultUser): UserListItem => ({
  id: user.id ?? '',
  firstName: user.firstName ?? null,
  lastName: user.lastName ?? null,
  email: user.email ?? null,
  phone: user.phone ?? null,
  dob: user.dob ?? null,
  isFriendsAndFam: user.isFriendsAndFam ?? null,
  insertedAt: user.insertedAt ?? null,
  programNames: distinctProgramNames(user.loans),
});
